export default __webpack_public_path__ + "static/media/facebook_icon-white.e737c02d.svg";